import React, {useEffect, useState} from 'react'
import {withAdr} from "../hoc-components/with-adr";
import compose from "utils/helper-functions/compose";
import {minStyles} from "variables/min-styles";
import {shallowEqual, useDispatch, useSelector} from "react-redux";
import {
    createStyles,
    defineBorderStyle,
    defineFontFamily,
    setVariablesStyle,
    getThemeEditorSettingsVariables
} from "utils/helper-functions/create-styles";
import {setBrandColors} from "utils/helper-functions/set-brand-colors";
import BootShell from "../helper-components/boot-shell/BootShell";
import {withPraxisService} from "../hoc-components";
import {perfBreak} from "utils/performance-functions/perf-break";
import InternalizationService from "../../context-components/internalization";
import {changeInitTheme} from "state/actions";
import {isPanoramicTheme} from "@pano-project/variables/is-panoramic-2-0-theme";
import {isDarkSystemAppearance} from "../../@pano-project/variables/theme-mode";
import {filterObject} from "../../utils/helper-functions/filter-object";

const i18n = new InternalizationService();

const PreparationStyles = (props) => {
    const {children, sMinStyles, praxisService: {timeInfoUpdate}} = props;
    const dispatch = useDispatch();
    const {encryptSelectors, cashier_theme} = useSelector(({
                                                               initTheme: {
                                                                   encryptSelectors,
                                                                   cashier_theme
                                                               }
                                                           }) =>
        ({cashier_theme, encryptSelectors}), shallowEqual);
    const {customization_settings} = useSelector(({
                                                 initTheme: {
                                                     theme_editor_settings:{customization_settings = {}} = {}
                                                 }
                                             }) =>
        ({customization_settings}), shallowEqual);
    let {appearance = '',
        brand_colors_light,
        brand_colors_dark,
        brand_text_colors_light,
        brand_text_colors_dark,
        button_style='',
        font=''
    } = customization_settings;
    const {getCustomStyles} = i18n;
    const [loader, setLoader] = useState(true);
    const [pciVariablesString, setPciVariablesString] = useState('');


    useEffect(() => {
        insertCustomCss();
        if (!isPanoramicTheme) {
            setLoader(false);
        } else {
            const themeAppearance = defineAppearance(appearance);
            const brandTextColorDark = brand_text_colors_dark ?? '#F2F2F2';
            const brandTextColorLight = brand_text_colors_light ?? '#F2F2F2';
            const primary_btn_color_text = themeAppearance === 'dark' ? brandTextColorDark : brandTextColorLight
            const themeObj = {
                border_style: defineBorderStyle(button_style),
                font_family: defineFontFamily(font),
                font_size: '16px',
                primary_btn_color_text,
                shadow_color: 'rgb(112, 144, 176)',
            }
            insertThemeVariables(themeAppearance, themeObj);
            setLoader(false);
        }
    }, [cashier_theme,
        button_style,
        font,
        appearance,
        brand_colors_dark,
        brand_colors_light,
        brand_text_colors_dark,
        brand_text_colors_light]
    )

    useEffect(() => {
        dispatch(changeInitTheme({pciVariablesStyle: `:root {${pciVariablesString}}`}));
    }, [pciVariablesString, appearance])

    const insertCustomCss = () => {
        if (encryptSelectors) encryptStyles();
        executeCashierCss(getCustomStyles());
    }

    const insertThemeVariables = (appearance, themeObj) => {
        const brandColorsDark = brand_colors_dark ?? '#0F758A';
        const brandColorsLight = brand_colors_light ?? '#0F768A';
        const colors = {primary: appearance === 'dark' ? brandColorsDark : brandColorsLight}
        const themeEditorVariables = getThemeEditorSettingsVariables(themeObj);
        setPciVariablesString(themeEditorVariables);
        applyBrandColors(appearance, filterObject({obj:colors, allowEmpty: true}));
        setVariablesStyle(themeEditorVariables, `:root`,'theme-editor-settings');
    }

    const defineAppearance = (appearance) => {
        if(appearance === 'system') return isDarkSystemAppearance ? 'dark' : 'light';
        return appearance;
    }

    const executeCashierCss = () => {
        let customStyles = getCustomStyles();
        if (customStyles) {
            if (encryptSelectors) customStyles = sMinStyles(customStyles, encryptSelectors)
            createStyles(customStyles)
        }
    }

    const encryptStyles = () => {
        const start = perfBreak()
        createStyles(sMinStyles(minStyles))
        const createEncryptStyles = (perfBreak() - start).toFixed(3);
        timeInfoUpdate({createEncryptStyles})
    }

    const applyBrandColors = (theme, colorsSet = {}) => {
        const pciColorsVariables = setBrandColors(theme, colorsSet);
        setPciVariablesString((prev) => `${prev} ${pciColorsVariables}`);
    }

    if (loader) return <BootShell/>;
    return children
}

export default compose(
    withAdr, withPraxisService()
)(PreparationStyles)


